// src/hooks/usePrismHighlighting.js
import { useEffect } from 'react'
import Prism from 'prismjs'

import 'prismjs/themes/prism.css';

// if you need to explicitly load languages (usually bundled by prismjs):
import 'prismjs/components/prism-markup.js';
import 'prismjs/components/prism-css.js';
import 'prismjs/components/prism-javascript.js';

export default function usePrismHighlighting(viewMode, content) {
  useEffect(() => {
    if (viewMode === 'code') Prism.highlightAll()
  }, [viewMode, content])
}
